import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getProspectusExtraDetails, saveBatchProspectusExtraDetails } from '../../api/prospectusExtraDetails';
import type { ProspectusExtraDetail } from '../../types/ProspectusExtraDetail';
import { t } from '../../i18n/t';

const columnDefs: ColDef<ProspectusExtraDetail>[] = [
  {
    field: 'extraDetailId',
    headerName: t('prospectusExtraDetails.columns.extraDetailId'),
    width: 140,
    cellDataType: 'number',
    editable: (p: EditableCallbackParams<ProspectusExtraDetail>) =>
      (p.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'extraDetailName',
    headerName: t('prospectusExtraDetails.columns.extraDetailName'),
    flex: 1,
    editable: true,
  },
];

const newRowDefaults = (): Partial<ProspectusExtraDetail> => ({ extraDetailId: 0, extraDetailName: '' });

export function ProspectusExtraDetailsPage() {
  return (
    <LopCrudPage<ProspectusExtraDetail>
      resourceCode="prospectusExtraDetails"
      titleKey="prospectusExtraDetails.pageTitle"
      idField="extraDetailId"
      getRows={getProspectusExtraDetails}
      saveBatch={(added, modified, deletedIds) => saveBatchProspectusExtraDetails(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
